module.exports = __webpack_public_path__ + "static/media/CVFY.15022745.png";